// extracted by mini-css-extract-plugin
export default {"projectWrapper":"project_projectWrapper__rJJEC","projectBackground":"project_projectBackground__Gqy2K","projectTop":"project_projectTop__ubiEi"};